import { cn } from "@utils";

const FormGroup = ({ className, children }) => {
  return (
    <div
      className={cn(
        "relative",
        className
      )}
    >
      {children}
    </div>
  );
};

export default FormGroup;

